import { useEffect } from "react";
import { tokenStore } from "@services/tokenStore";
import { useSession } from "@hooks/useSession";
import { useGetDashboardFocusedFeaturesContext } from "../../FocusedFeatures/Dashbaord/useGetDashboardFocusedFeaturesContext";
import { IS_DEV_ENV } from "../../shared/constants/environment";

export const SystemLog = () => {
  const userContext = useGetDashboardFocusedFeaturesContext();
  const { personId } = useSession();
  const preferredAccountId = tokenStore.getPreferredAccountId(personId);
  const isUserContextReady = !!userContext;

  useEffect(() => {
    if (isUserContextReady) {
      const { customization, experiments, ...userSettings } = userContext;
      const extendedSettings = {
        ...userSettings,
        preferredAccountId
      };

      Object.entries(extendedSettings).forEach(([key, value]) => {
        const title = `USER_SETTINGS( ${key} )`;
        const content = JSON.stringify(value, null, 2);

        const body = `${title}\n${content}`;

        if (IS_DEV_ENV) {
          console.info(body);
        }

        window.FS?.("log", {
          level: "info",
          msg: body
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserContextReady]);

  return null;
};
